/** Dead code ? :D */

export const go = path => (action, store, { router }) => {
  router.push(path)
}

export const setScreenName = (action, store, { router }) => {
  if (!router.isFound()) return
  const [name, subName] = router.getCurrentCode().split('_')
  store.ui.screen.name.set(name)
  if (subName) store.ui.screen.subName.set(subName)
  else store.ui.screen.subName.reset()
}

export const goToHome = (action, store, { window, router }) => {
  if (!router.isFound()) return
  window.document.location.assign('/')
}
